import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './output.css';
import './index.css';

import AcquisitionIntelInterface from './App';
import AcquisitionIntelDashboard from './App_dash';
import AcquisitionIntelReports from './App_reports';
import PortfolioPage from './PortfolioPage';

import { AuthProvider } from './AuthContext';
import ProtectedRoute from './ProtectedRoute';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
     <AuthProvider>
      <Router>
        <Routes>
          <Route
            path="/dashboard"
            element={
               <ProtectedRoute>
                 <AcquisitionIntelDashboard />
              </ProtectedRoute>
   
            }
          />
          <Route
            path="/analysis"
            element={
               <ProtectedRoute>
                 <AcquisitionIntelInterface />
              </ProtectedRoute>
     
            }
          />
          <Route
            path="/portfolio"
            element={
              <ProtectedRoute>
                <PortfolioPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports"
            element={
               <ProtectedRoute>
                 <AcquisitionIntelReports />
               </ProtectedRoute>
             
            }
          />
          <Route path="/" element={<Navigate to="/analysis" />} />
        </Routes>
      </Router>
     </AuthProvider> 
  </React.StrictMode>
);

reportWebVitals();
